import React from "react";

export function PriceToggle({ value, onChange, testid = "price", small, defaultPaid = "0.99" }) {
  const paid = Number(value) > 0;
  const btn = (active, extra) =>
    `${small ? "px-3 py-1 text-[11px]" : "px-4 py-1.5 text-xs"} rounded-full font-semibold transition-colors ${
      active ? extra : "bg-white/5 text-white/50 hover:text-white border border-white/10"
    }`;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <button type="button" data-testid={`${testid}-free`} onClick={() => onChange("0")}
        className={btn(!paid, "bg-emerald-500/20 text-emerald-400 border border-emerald-500/40")}>Gratis</button>
      <button type="button" data-testid={`${testid}-paid`} onClick={() => !paid && onChange(defaultPaid)}
        className={btn(paid, "bg-red-600/25 text-red-400 border border-red-600/50")}>De pago</button>
      {paid && (
        <div className="flex items-center gap-1">
          <span className="text-white/50 text-xs">€</span>
          <input type="number" min="0.5" step="0.01" value={value} data-testid={`${testid}-amount`}
            onChange={(e) => onChange(e.target.value)}
            className={`bg-[#16161D] border border-white/10 rounded-lg px-2 text-white ${small ? "py-1 text-xs w-20" : "py-1.5 text-sm w-24"}`} />
        </div>
      )}
    </div>
  );
}
